import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanActivateFn } from '@angular/router';
import {
  AccessabilityDialogComponent,
  MustBeLoginData,
} from '@components/dialogs/accessability-dialog/accessability-dialog.component';
import { GeneralService } from '@shared/services/general.service';
import { TokenService } from '@shared/services/token.service';

/**
 * Based on this function we handled permission of show a page to user or not
 *
 * @param route
 * @param state
 * @returns The boolean of a user logged in or not
 * @author : @faridghafoori
 */
export const accessGuard: CanActivateFn = (route, state) => {
  const generalService = inject(GeneralService);
  const tokenService = inject(TokenService);
  const dialog = inject(MatDialog);

  if (generalService.isBrowserOnly) {
    if (tokenService.getRtk()?.length) {
      return true;
    }
  }
  generalService.router.navigate(['/auth'], {
    queryParams: {
      ru: state.url,
    },
  });
  const dialogData: MustBeLoginData = {
    linkTitle: 'باشه',
    isForceClose: true,
  };
  dialog.open(AccessabilityDialogComponent, {
    data: dialogData,
  });
  return false;
};
